export default function LudoIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="4" y="4" width="56" height="56" rx="8" fill="#F4F7FB" />
      <rect x="4" y="4" width="22" height="22" rx="6" fill="#3D8F63" />
      <rect x="38" y="4" width="22" height="22" rx="6" fill="#FF8A1F" />
      <rect x="4" y="38" width="22" height="22" rx="6" fill="#2F8BFF" />
      <rect x="38" y="38" width="22" height="22" rx="6" fill="#C9A227" />
      <path d="M26 26h12v12H26z" fill="#fff" />
      <path d="M26 26l6 6-6 6zM38 26l-6 6 6 6z" fill="#2F8BFF" />
      <path d="M26 26l6 6 6-6zM26 38l6-6 6 6z" fill="#FF8A1F" />
      <circle cx="15" cy="49" r="6" fill="#164787" />
      <circle cx="15" cy="48" r="5" fill="#8CC6FF" />
      <circle cx="49" cy="15" r="6" fill="#8A4410" />
      <circle cx="49" cy="14" r="5" fill="#FFC285" />
      <rect x="40" y="40" width="16" height="16" rx="4" fill="#fff" stroke="#1D2433" strokeWidth="2" />
      <circle cx="44.5" cy="44.5" r="1.8" fill="#1D2433" />
      <circle cx="48" cy="48" r="1.8" fill="#1D2433" />
      <circle cx="51.5" cy="51.5" r="1.8" fill="#1D2433" />
    </svg>
  );
}
